import { combineReducers } from 'redux';
import clientReducer from './clientInfo.reducer';
import loginReducer from './login.reducer';
import incidentReducer from './incident.reducer';
import instance from './instance.reducer';
import createInstanceReducer from './createInstance.reducer';
import applicationsReducer from './applications.reducer';
import sidebarReducer from './sidebar.reducer';
import userReducer from './user.reducer';
import customScreensReducer from './configscreens.reducer';
import customerAccessReducer from './customerAccess.reducer';
import customLoginUsersReducer from './customLoginUsers.reducer';
import constantsReducer from './constants.reducer';

export default combineReducers({
    clientReducer,
    loginReducer,
    instance,
    createInstanceReducer,
    incidentReducer,
    applicationsReducer,
    userReducer,
    customScreensReducer,
    sidebar: sidebarReducer,
    customerAccessReducer,
    customLoginUsersReducer,
    constants: constantsReducer,
});
